/**
 * 단순히 IDE 코드하이라이트를 위한 용도로 만들어짐 특별한 기능이 없음
 * @param {TemplateStringsArray} strings
 * @param {...*} values
 */
export function html(strings, ...values) {
  return strings.reduce((result, string, i) => {
    return result + string + (values[i] || '');
  }, '');
}